import React from "react";
import Input from "components/input/Input";

export function EmailInput({
  value,
  setValue,
  error,
  disableError,
  placeholder,
  className,
  ...rest
}) {
  return (
    <Input
      type="email"
      placeholder={placeholder}
      value={value}
      maxLength={128}
      className={className}
      error={error}
      onChange={(event) => {
        setValue(event.target.value);
        disableError && disableError();
      }}
      {...rest}
    />
  );
}

EmailInput.defaultProps = {
  value: "",
  setValue: () => null,
  error: null,
  disableError: () => null,
  placeholder: "E-mail",
  className: "",
};
